(function () {
  'use strict';

  var MOBILE_BP = 990;

  function isMobile() {
    return window.innerWidth < MOBILE_BP;
  }

  function init() {
    // Use capture phase on the NAV itself to intercept before Horizon does
    var nav = document.querySelector('nav[header-menu]');
    if (!nav) return;

    nav.addEventListener('click', function (e) {
      var link = e.target.closest('[data-parent-toggle]');
      if (!link) return;

      var href = link.getAttribute('href');

      // Stop Horizon handling this click
      e.stopImmediatePropagation();

      // Toggle aria-expanded for dropdown CSS
      var isExpanded = link.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('[data-parent-toggle][aria-expanded="true"]')
        .forEach(function (other) {
          if (other !== link) other.setAttribute('aria-expanded', 'false');
        });

      link.setAttribute('aria-expanded', String(!isExpanded));

      // Always navigate
      if (href && href !== '#' && href !== 'javascript:void(0)') {
        window.location.href = href;
      }

    }, true); // capture phase = we run first

    // Desktop hover sync
    document.querySelectorAll('[data-parent-toggle]').forEach(function (link) {
      var li = link.closest('.menu-list__list-item');
      if (!li) return;

      li.addEventListener('pointerenter', function () {
        if (!isMobile()) link.setAttribute('aria-expanded', 'true');
      });

      li.addEventListener('pointerleave', function () {
        if (!isMobile()) link.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Retry until nav[header-menu] exists (Horizon renders it async)
  function waitForNav() {
    if (document.querySelector('nav[header-menu]')) {
      init();
    } else {
      setTimeout(waitForNav, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForNav);
  } else {
    waitForNav();
  }

})();